module.exports = __webpack_public_path__ + "static/media/circledLineLong.58b82a40.svg";